import { SR_API_ACTION_APARTMENT_LOCATOR_UPDATE_LEAD_STATUS } from 'api/actionTypes';

export default async function updateLeadStatus(
  { state, apiClient },
  { apartmentLocatorUserId, renterUserId, fromLeadStatus, toLeadStatus, entityTransitionUpdates }
) {
  await apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_LOCATOR_UPDATE_LEAD_STATUS,
    queryId: String(renterUserId),
    state: state,
    payload: {
      apartmentLocatorUserId,
      renterUserId,
      leadStatus: toLeadStatus,
      entityTransitionUpdates: entityTransitionUpdates,
    },
    onSuccess() {
      state.set(['apartmentLocator', 'leadsUpdated', renterUserId], {
        fromLeadStatus,
        toLeadStatus,
      });
      state.commit();
    },
  });
}
